<template>
  <v-container>
    <v-card tile class="elevation-1">
      <v-tabs
        v-model="tab"
        height="35px"
        grow
        show-arrows
        :background-color="tabsBackground"
      >
        <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="pb-6">
        <v-tab-item v-for="item in items" :key="item.tab">
          <v-card flat>
            <component v-bind:is="item.content"></component>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import i18n from "../i18n";
import UsersTable from "../components/Permissions/Users/UsersTable.vue";
import TokensTable from "../components/Permissions/Tokens/TokensTable.vue";
import RolesTable from "../components/Permissions/Roles/RolesTable.vue";

export default {
  name: "Permissions",
  components: {
    UsersTable,
    TokensTable,
    RolesTable,
  },
  props: {
    source: String,
  },
  computed: {
    tabsBackground() {
      if (this.$vuetify.theme.dark) {
        return "grey darken-2";
      } else {
        return "grey lighten-4";
      }
    },
  },
  mounted() {
    // Permissions
    let permissions = this.$store.getters.resources.permissions;

    if (permissions.users.read) {
      this.items.push({
        tab: i18n.t("Users"),
        content: "UsersTable",
      });
    }

    if (permissions.tokens.read) {
      this.items.push({
        tab: i18n.t("Tokens"),
        content: "TokensTable",
      });
    }

    if (permissions.roles.read) {
      this.items.push({
        tab: i18n.t("Roles"),
        content: "RolesTable",
      });
    }
  },
  data: () => ({
    tab: null,
    items: [],
  }),
  methods: {
    mainMenu() {},
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
</style>